import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiNg = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.999 0.746994V23.247",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.249 11.997H0.749001",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.999 11.997C2.999 14.3839 3.94721 16.6731 5.63504 18.361C7.32287 20.0488 9.61205 20.997 11.999 20.997C14.3859 20.997 16.6751 20.0488 18.363 18.361C20.0508 16.6731 20.999 14.3839 20.999 11.997C20.999 9.61005 20.0508 7.32086 18.363 5.63303C16.6751 3.94521 14.3859 2.99699 11.999 2.99699C9.61205 2.99699 7.32287 3.94521 5.63504 5.63303C3.94721 7.32086 2.999 9.61005 2.999 11.997Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.499 11.997C7.499 13.1905 7.97311 14.3351 8.81702 15.179C9.66093 16.0229 10.8055 16.497 11.999 16.497C13.1925 16.497 14.3371 16.0229 15.181 15.179C16.0249 14.3351 16.499 13.1905 16.499 11.997C16.499 10.8035 16.0249 9.65893 15.181 8.81501C14.3371 7.9711 13.1925 7.49699 11.999 7.49699C10.8055 7.49699 9.66093 7.9711 8.81702 8.81501C7.97311 9.65893 7.499 10.8035 7.499 11.997Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTiNg;
